module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('vue-headful', {
    attrs: {
      "title": _vm.loading.tela ? 'Carregando aditivo' : 'Aditivo ' + (!_vm._.isNull(_vm.id) ? 'ID ' + _vm.id : '')
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_c('span', {
    staticClass: "col-md-5"
  }, [_vm._v(_vm._s(_vm.loading.tela ? 'Carregando aditivo...' : 'Aditivo ' + (!_vm._.isNull(_vm.id) ? 'ID ' + _vm.id : '')))]), _vm._v(" "), _c('span', [(!_vm.loading.tela) ? _c('span', {
    staticClass: "col-md-7 bloco_botoes"
  }, [_c('g-button-moema', {
    attrs: {
      "color": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.imprimir($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Visualizar")])], 1) : _vm._e()])])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box box-widget",
    staticStyle: {
      "min-height": "200px"
    }
  }, [(_vm.loading.tela || _vm._.isEmpty(_vm.solicitacao.aditivo.conteudo)) ? _c('div', [_vm._m(0)]) : _c('div', [_c('div', {
    staticClass: "box-header with-border hidden-print"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.solicitacao.aditivo.modelo.nome))])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-md-12",
    attrs: {
      "id": "editorAditivo"
    }
  }, [_c('quill-editor', {
    attrs: {
      "disabled": _vm.desabilitarEditor,
      "options": _vm.quillOptions
    },
    model: {
      value: (_vm.solicitacao.aditivo.conteudo),
      callback: function($$v) {
        _vm.$set(_vm.solicitacao.aditivo, "conteudo", $$v)
      },
      expression: "solicitacao.aditivo.conteudo"
    }
  })], 1)])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8323cbc0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/solicitacoes/alteracoesProjeto/Aditivo.vue
// module id = 2036
// module chunks = 1